(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('ApplicationTypeService', ApplicationTypeService)

    /** @ngInject */
    function ApplicationTypeService(HttpService) {
        const ApplicationTypeService = {
            getAll: getAll
        }

        return ApplicationTypeService;

        function getAll() {
            return HttpService.get('/applications/types');
        }
    }
}());